import { useContext } from "react";
import { KycConfirmationContext } from "../contexts/KycConfirmationContext";

export const useKycConfirmation = () => useContext(KycConfirmationContext);
